export default {
  name: 'PolteqButton',
  props: ['buttonId', 'icon', 'buttonText']
};
